import React, {useState, useEffect} from 'react';
import {Row, Col, Button, Icon, Select, Input, Modal, message} from 'antd'
import { useTranslation } from 'react-i18next';
import {saveRegStatePromise} from '../../../../promises'

const CambioEstado = ({currentUser, itemTable, forceExpand}) => {
    const [seeMore, setSeeMore] = useState(forceExpand);
    const [selectedStatus, setSelectedStatus] = useState();
    const [statusComments, setStatusComments] = useState();

    const { t } = useTranslation();

    const varStateOptions = (actualState) => {
        var options = [];
        if (actualState === null)  {
            options.push({val: "AUTORIZADA", label: t("messages.aml.authorized")}, {val: "RECHAZADA", label: t("messages.aml.rejected")})
        }
        if (actualState === 'AUTORIZADA'){
            options.push({val: "RECHAZADA", label: t("messages.aml.rejected")});
        }else if(actualState === 'RECHAZADA'){
            options.push({val: "AUTORIZADA", label: t("messages.aml.authorized")});
        }
        return options
    }

    const handleSaveStatus = () => {
        saveRegStatePromise(itemTable.id, selectedStatus, statusComments).then((response) => {
            if(response){
                message.success(t("messages.aml.statusSaved"));
                setSelectedStatus(null);
            }else{
                message.error(t("messages.aml.errorSavingStatus"))
                setSelectedStatus(null);
            }
        })
    }


    return (
        <div>
            <Row>
                <Col span={22}>
                    <h3>{t("messages.aml.changeStatus")}</h3>
                </Col>
                <Col span={2} style={{textAlign:'right'}}>
                    <Button type="link" onClick={() => setSeeMore(!seeMore)}>
                    {seeMore ?
                        <>{t("messages.aml.seeLess")} <Icon type="minus"/></>
                        :
                        <>{t("messages.aml.seeMore")} <Icon type="plus"/></>
                    }
                    </Button>
                </Col>
            </Row>
            <hr/>
            {seeMore &&
            <div className={forceExpand ? "status-box" : "status-box div-more-info"} style={{padding: 20}}>
                <Row gutter={[68, 0]}>
                    <Col span={6} >
                        <h3>{t("messages.aml.modifyStatus")}</h3>
                    </Col>
                    <Col span={8} push={10}>
                        <Select
                            style={{width: '100%'}}
                            placeholder={t("messages.aml.selectStatus")}
                            defaultValue={itemTable.statusRec}
                            onChange={(e) => setSelectedStatus(e)}
                            disabled={currentUser.type === 'AUDIT'}
                            >
                                {varStateOptions(itemTable.statusRec).map(option =>
                                    <Select.Option value={option.val}>{option.label}</Select.Option>
                                )
                                }
                        </Select>
                    </Col>
                </Row>
                {selectedStatus &&
                <Modal
                    title={t("messages.aml.changeStatus")}
                    centered
                    width={700}
                    visible="true"
                    onCancel={() => setSelectedStatus(null)}
                    footer={[
                    <Button key="save" onClick={() => handleSaveStatus()}>{t("messages.aml.save")}</Button>
                    ]}
                    >
                    <Row>
                        <Col span={24}>
                        {t("messages.aml.requestedChangeStatus")} {t("messages.aml.formKycStatus."+selectedStatus)}. <br/>
                        {t("messages.aml.addCommentsRecord")}
                        </Col>
                    </Row>
                    <Row gutter={[0, 32]}>
                        <Col span={24}>
                        <Input.TextArea placeholder={t("messages.aml.addCommentsMax")} onChange={(e) => setStatusComments(e.target.value)} />
                        </Col>
                    </Row>
                </Modal>
                }
            </div>
            }
        </div>
    );
};

export default CambioEstado;